/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** ConversationReportItemType */
export enum ConversationReportItemType {
  Summary = "summary",
  ActionItem = "action_item",
  Decision = "decision",
  Question = "question",
  AgendaItem = "agenda_item",
  Text = "text",
}

/** Body_finalize_call_with_file_internal_conversation_finalize_call_with_file_post */
export interface BodyFinalizeCallWithFileInternalConversationFinalizeCallWithFilePost {
  /** Payload */
  payload: string;
  /** File */
  file?: File | null;
}

/** ChunkEnqueueResponse */
export interface ChunkEnqueueResponse {
  /** Conversation Id */
  conversation_id: string;
  /** Chunk Id */
  chunk_id: number;
  /** Created New Conversation */
  created_new_conversation: boolean;
}

/** ChunkPayload */
export interface ChunkPayload {
  /** Conversation Id */
  conversation_id: string;
  /** Workspace Id */
  workspace_id?: string | null;
  /** Provider Id */
  provider_id?: string | null;
  /** Provider External Id */
  provider_external_id?: string | null;
  /** Participant Id */
  participant_id?: string | null;
  /** Provider User Id */
  provider_user_id?: string | null;
  /** Provider User Name */
  provider_user_name?: string | null;
  /** Provider User Display Name */
  provider_user_display_name?: string | null;
  /** Payload Type */
  payload_type?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
  /**
   * Text
   * @default ""
   */
  text?: string;
  /** Begin Ts */
  begin_ts?: string | null;
  /** End Ts */
  end_ts?: string | null;
}

/** ConversationChunkItem */
export interface ConversationChunkItem {
  /** Id */
  id: number;
  /** Begin Ts */
  begin_ts?: string | null;
  /** End Ts */
  end_ts?: string | null;
  /** Display Name */
  display_name?: string | null;
  /** Text */
  text: string;
  /** Participant Id */
  participant_id?: string | null;
  /** Provider User Id */
  provider_user_id?: string | null;
  /** Payload Type */
  payload_type?: string | null;
}

/** ConversationChunksResponse */
export interface ConversationChunksResponse {
  /** Items */
  items: ConversationChunkItem[];
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
}

/** ConversationCompletePayload */
export interface ConversationCompletePayload {
  /** Ended At */
  ended_at?: string | null;
  /** Reason */
  reason?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
}

/** ConversationCreatePayload */
export interface ConversationCreatePayload {
  /** Provider Id */
  provider_id: string;
  /** Workspace Id */
  workspace_id: string;
  /** Title */
  title?: string | null;
  /** External Id */
  external_id?: string | null;
  /** Scheduled At */
  scheduled_at?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
  /** Participants */
  participants?: ParticipantPayload[];
}

/** ConversationFinalizePayload */
export interface ConversationFinalizePayload {
  /** Finalized By */
  finalized_by?: string | null;
  /** Ended At */
  ended_at?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
  /** Result */
  result?: string | null;
}

/** ConversationListItem */
export interface ConversationListItem {
  /** Conversation Id */
  conversation_id: string;
  /** Status */
  status: string;
  /** Provider Id */
  provider_id: string;
  /** Workspace Id */
  workspace_id: string;
  /** Meeting Group Id */
  meeting_group_id?: string | null;
  /** Started At */
  started_at?: string | null;
  /** Ended At */
  ended_at?: string | null;
}

/** ConversationListResponse */
export interface ConversationListResponse {
  /** Items */
  items: ConversationListItem[];
}

/** ConversationMergeRequest */
export interface ConversationMergeRequest {
  /**
   * Conversation Ids
   * IDs of conversations to merge
   * @minItems 2
   */
  conversation_ids: string[];
}

/** ConversationMergeResponse */
export interface ConversationMergeResponse {
  conversation: ConversationStatusResponse;
  /** Chunks */
  chunks: ConversationChunkItem[];
}

/** ConversationReportCreate */
export interface ConversationReportCreate {
  /** Title */
  title: string;
}

/** ConversationReportDTO */
export interface ConversationReportDTO {
  /** Id */
  id: string;
  /** Conversation Id */
  conversation_id: string;
  /** Title */
  title: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at?: string | null;
}

/** ConversationReportItemCreate */
export interface ConversationReportItemCreate {
  /** Title */
  title: string;
  type: ConversationReportItemType;
  /** Data */
  data?: Record<string, any> | null;
}

/** ConversationReportItemDTO */
export interface ConversationReportItemDTO {
  /** Id */
  id: string;
  /** Report Id */
  report_id: string;
  /** Title */
  title: string;
  type: ConversationReportItemType;
  /** Data */
  data?: Record<string, any>;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** ConversationReportItemUpdate */
export interface ConversationReportItemUpdate {
  /** Title */
  title: string;
  /** Data */
  data?: Record<string, any> | null;
}

/** ConversationReportWithItemsCreate */
export interface ConversationReportWithItemsCreate {
  /** Title */
  title: string;
  /** Items */
  items?: ConversationReportItemCreate[];
}

/** ConversationReportWithItemsDTO */
export interface ConversationReportWithItemsDTO {
  /** Id */
  id: string;
  /** Conversation Id */
  conversation_id: string;
  /** Title */
  title: string;
  /** Items */
  items?: ConversationReportItemDTO[];
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** ConversationReportsBatchCreate */
export interface ConversationReportsBatchCreate {
  /** Conversation Id */
  conversation_id?: string | null;
  /** Items */
  items: ConversationReportWithItemsCreate[];
}

/** ConversationStartPayload */
export interface ConversationStartPayload {
  /** Started By */
  started_by?: string | null;
  /** Started At */
  started_at?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
}

/** ConversationStatusResponse */
export interface ConversationStatusResponse {
  /** Conversation Id */
  conversation_id: string;
  /** Status */
  status: string;
  /** Substatus */
  substatus?: string | null;
  /** Started At */
  started_at: string | null;
  /** Ended At */
  ended_at: string | null;
  /** Workspace Id */
  workspace_id: string;
  /** Provider Id */
  provider_id: string;
  /** Metadata */
  metadata: Record<string, any>;
}

/** ConversationStatusUpdateRequest */
export interface ConversationStatusUpdateRequest {
  /** Status */
  status?: string | null;
  /** Substatus */
  substatus?: string | null;
}

/** EventPayload */
export interface EventPayload {
  /** Provider Id */
  provider_id: string;
  /** Workspace Id */
  workspace_id: string;
  /** Conversation Id */
  conversation_id: string;
  /** Event Type */
  event_type: string;
  /** Payload */
  payload?: Record<string, any>;
}

/** FinalizeCallResponse */
export interface FinalizeCallResponse {
  /** Accepted */
  accepted: boolean;
  /** Conversation Id */
  conversation_id: string;
}

/** GuildSummary */
export interface GuildSummary {
  /** Discord Guild Id */
  discord_guild_id: string;
  /** Label */
  label: string;
  /** Status */
  status: string;
  /**
   * Transcription
   * @default false
   */
  transcription?: boolean;
  /** Created At */
  created_at?: string | null;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** IngestChunkRequest */
export interface IngestChunkRequest {
  /** Guild Id */
  guild_id: string;
  /** Session Hint */
  session_hint?: Record<string, any> | null;
  chunk: InternalChunk;
  /** Provider Id */
  provider_id?: string | null;
  /** Workspace Id */
  workspace_id?: string | null;
  /** Conversation Id */
  conversation_id?: string | null;
  /** Participant Id */
  participant_id?: string | null;
  /** Provider User Id */
  provider_user_id?: string | null;
  /** Source */
  source?: Record<string, any> | null;
  /** Sequence */
  sequence?: number | null;
}

/** IngestChunkResponse */
export interface IngestChunkResponse {
  /** Accepted */
  accepted: boolean;
  /** Conversation Id */
  conversation_id: string;
  /** Chunk Id */
  chunk_id: number;
}

/** InternalChunk */
export interface InternalChunk {
  /** Begin Ts */
  begin_ts?: string | null;
  /** End Ts */
  end_ts?: string | null;
  /** Provider User Id */
  provider_user_id?: string | null;
  /** Provider User Name */
  provider_user_name?: string | null;
  /** Provider User Display Name */
  provider_user_display_name?: string | null;
  /** Text */
  text: string;
  /** Raw */
  raw?: Record<string, any> | null;
  /** Participant Id */
  participant_id?: string | null;
  /** Payload Type */
  payload_type?: string | null;
  /** Metadata */
  metadata?: Record<string, any> | null;
}

/** InviteResponse */
export interface InviteResponse {
  /** Invite Url */
  invite_url: string;
}

/** LinkGuildRequest */
export interface LinkGuildRequest {
  /**
   * Guild Id
   * Discord Guild ID
   */
  guild_id: string;
}

/** LinkGuildResponse */
export interface LinkGuildResponse {
  /** Guild Id */
  guild_id: string;
  /** Linked */
  linked: boolean;
}

/** LinkedGuildResponse */
export interface LinkedGuildResponse {
  /** Linked */
  linked: boolean;
}

/** MeetChunkRequest */
export interface MeetChunkRequest {
  /** Text */
  text: string;
  /** Start Time */
  start_time: number;
  /** End Time */
  end_time: number;
  /** Confidence */
  confidence: number;
  /** Timestamp */
  timestamp: string;
  /** Participant Name */
  participant_name?: string | null;
}

/** MeetChunkResponse */
export interface MeetChunkResponse {
  /** Accepted */
  accepted: boolean;
  /** Conversation Id */
  conversation_id?: string | null;
  /** Chunk Id */
  chunk_id?: number | null;
}

/** MeetWorkspaceCreateRequest */
export interface MeetWorkspaceCreateRequest {
  /** Name */
  name: string;
  /** Default Meeting Group Id */
  default_meeting_group_id?: string | null;
}

/** MeetWorkspaceCreateResponse */
export interface MeetWorkspaceCreateResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Room Id */
  room_id: string;
  /** Meet Room Id */
  meet_room_id: string;
  /** Slug */
  slug: string;
  /** Webhook Url */
  webhook_url: string;
  /** Room Url */
  room_url: string;
  /** Pin Code */
  pin_code?: string | null;
}

/** MeetWorkspaceDetailResponse */
export interface MeetWorkspaceDetailResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Room Id */
  room_id: string;
  /** Meet Room Id */
  meet_room_id: string;
  /** Slug */
  slug: string;
  /** Room Url */
  room_url: string;
  /** Pin Code */
  pin_code?: string | null;
  /** Display Name */
  display_name?: string | null;
}

/** MeetingGroupCreateRequest */
export interface MeetingGroupCreateRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 128
   */
  name: string;
  /** Description */
  description?: string | null;
}

/** MeetingGroupListResponse */
export interface MeetingGroupListResponse {
  /** Items */
  items: MeetingGroupResponse[];
}

/** MeetingGroupMember */
export interface MeetingGroupMember {
  /** User Id */
  user_id: string;
  /** Role */
  role: string;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** MeetingGroupMemberAddRequest */
export interface MeetingGroupMemberAddRequest {
  /**
   * User Id
   * @minLength 1
   * @maxLength 128
   */
  user_id: string;
  /**
   * Role
   * @minLength 1
   * @maxLength 32
   * @default "member"
   */
  role?: string;
}

/** MeetingGroupResponse */
export interface MeetingGroupResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
  /** Members */
  members?: MeetingGroupMember[];
}

/** MeetingGroupUpdateRequest */
export interface MeetingGroupUpdateRequest {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
}

/** PaginatedResponse[GuildSummary] */
export interface PaginatedResponseGuildSummary {
  /** Items */
  items: GuildSummary[];
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Total Pages */
  total_pages: number;
}

/** ParticipantPayload */
export interface ParticipantPayload {
  /** External Id */
  external_id?: string | null;
  /** Display Name */
  display_name?: string | null;
  /** Role */
  role?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
  /** Participant Id */
  participant_id?: string | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
}

/** ProtocolAnswer */
export interface ProtocolAnswer {
  /** Answer */
  answer: string;
}

/** ProviderItem */
export interface ProviderItem {
  /** Id */
  id: string;
  /** Provider Type */
  provider_type: string;
  /** Name */
  name: string;
  /** Capabilities */
  capabilities?: Record<string, any>;
  /** Is Active */
  is_active: boolean;
}

/** ProviderListResponse */
export interface ProviderListResponse {
  /** Items */
  items: ProviderItem[];
}

/** ReportItemInfo */
export interface ReportItemInfo {
  /** Id */
  id: string;
  /** Title */
  title: string;
}

/** ReportTreeResponse */
export interface ReportTreeResponse {
  /** Reports */
  reports: ReportWithItemsInfo[];
}

/** ReportWithItemsInfo */
export interface ReportWithItemsInfo {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Items */
  items: ReportItemInfo[];
}

/** StatusMappingsResponse */
export interface StatusMappingsResponse {
  /** Status */
  status: Record<string, string>;
  /** Substatus */
  substatus: Record<string, string>;
}

/** TestChunkPayload */
export interface TestChunkPayload {
  /** Text */
  text: string;
  /** Participant Id */
  participant_id?: string | null;
  /** Provider User Id */
  provider_user_id?: string | null;
  /** Provider User Name */
  provider_user_name?: string | null;
  /** Provider User Display Name */
  provider_user_display_name?: string | null;
  /** Display Name */
  display_name?: string | null;
  /** Begin Ts */
  begin_ts?: string | null;
  /** End Ts */
  end_ts?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
}

/** TestChunksRequest */
export interface TestChunksRequest {
  /**
   * Chunks
   * @minItems 1
   */
  chunks: TestChunkPayload[];
}

/** TestChunksResponse */
export interface TestChunksResponse {
  /** Conversation Id */
  conversation_id: string;
  /** Chunks Created */
  chunks_created: number;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** VoiceChannelSummary */
export interface VoiceChannelSummary {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Bitrate */
  bitrate: number;
  /** User Limit */
  user_limit?: number | null;
  /** Is Connected */
  is_connected: boolean;
  /** Provider Id */
  provider_id?: string | null;
}

/** VoiceChannelsResponse */
export interface VoiceChannelsResponse {
  /** Channels */
  channels: VoiceChannelSummary[];
}

/** VoiceConnectRequest */
export interface VoiceConnectRequest {
  /** Guild Id */
  guild_id: string;
  /** Channel Id */
  channel_id: string;
  /** Meeting Group Id */
  meeting_group_id?: string | null;
}

/** VoiceDisconnectRequest */
export interface VoiceDisconnectRequest {
  /** Guild Id */
  guild_id: string;
}

/** VoiceOperationResponse */
export interface VoiceOperationResponse {
  /** Ok */
  ok: boolean;
  /** Conversation Id */
  conversation_id?: string | null;
}

/** WebhookProtocolRequest */
export interface WebhookProtocolRequest {
  /** Conversation Id */
  conversation_id: string;
  /** Responses */
  responses: WebhookResponseItem[] | Record<string, ProtocolAnswer>;
  general?: ProtocolAnswer | null;
}

/** WebhookResponseItem */
export interface WebhookResponseItem {
  /** User Id */
  user_id: string;
  /** Answer */
  answer: string;
}

/** WorkspaceCreatePayload */
export interface WorkspaceCreatePayload {
  /** External Id */
  external_id: string;
  /** Display Name */
  display_name?: string | null;
  /** Settings */
  settings?: Record<string, any>;
  /** Metadata */
  metadata?: Record<string, any>;
  /** Default Meeting Group Id */
  default_meeting_group_id?: string | null;
}

/** WorkspaceCreateResponse */
export interface WorkspaceCreateResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Provider Id */
  provider_id: string;
}

/** WorkspaceDeleteResponse */
export interface WorkspaceDeleteResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Deleted */
  deleted: boolean;
}

/** WorkspaceItem */
export interface WorkspaceItem {
  /** Workspace Id */
  workspace_id: string;
  /** Provider Id */
  provider_id: string;
  /** External Id */
  external_id: string | null;
  /** Display Name */
  display_name: string | null;
  /** Owner App User Id */
  owner_app_user_id: string | null;
  /** Is Active */
  is_active: boolean;
  /** Metadata */
  metadata: Record<string, any>;
}

/** WorkspaceListResponse */
export interface WorkspaceListResponse {
  /** Items */
  items: WorkspaceItem[];
}

/** WorkspaceResponse */
export interface WorkspaceResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Provider Id */
  provider_id: string;
  /** External Id */
  external_id?: string | null;
  /** Display Name */
  display_name?: string | null;
  /** Owner App User Id */
  owner_app_user_id?: string | null;
  /** Is Active */
  is_active: boolean;
  /** Metadata */
  metadata: Record<string, any>;
  /** Default Meeting Group Id */
  default_meeting_group_id?: string | null;
}

/** WorkspaceUpdateRequest */
export interface WorkspaceUpdateRequest {
  /** Default Meeting Group Id */
  default_meeting_group_id?: string | null;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Volo Discord Integration API
 * @version 0.1.0
 *
 * REST API и WebSocket для интеграции Discord-бота: управление сессиями транскрипции, получение последних транскрипций и события в реальном времени. Все запросы требуют JWT (Bearer).
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  internal = {
    /**
     * No description
     *
     * @tags Internal
     * @name IngestChunkInternalConversationChunkPost
     * @summary Добавить чанк транскрипции (внутренний)
     * @request POST:/internal/conversation/chunk
     * @secure
     */
    ingestChunkInternalConversationChunkPost: (
      data: IngestChunkRequest,
      params: RequestParams = {},
    ) =>
      this.request<IngestChunkResponse, HTTPValidationError>({
        path: `/internal/conversation/chunk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name IsGuildLinkedInternalGuildsLinkedGet
     * @summary Проверить, привязана ли гильдия (по X-Bot-Token)
     * @request GET:/internal/guilds/linked
     * @secure
     */
    isGuildLinkedInternalGuildsLinkedGet: (params: RequestParams = {}) =>
      this.request<LinkedGuildResponse, HTTPValidationError>({
        path: `/internal/guilds/linked`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name CompleteConversationInternalConversationsConversationIdCompletePost
     * @summary Завершить конверсацию (внутренний)
     * @request POST:/internal/conversations/{conversation_id}/complete
     * @secure
     */
    completeConversationInternalConversationsConversationIdCompletePost: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/internal/conversations/${conversationId}/complete`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name FinalizeCallWithFileInternalConversationFinalizeCallWithFilePost
     * @summary Финализировать разговор (файл записи опционален)
     * @request POST:/internal/conversation/finalize_call_with_file
     * @secure
     */
    finalizeCallWithFileInternalConversationFinalizeCallWithFilePost: (
      data: BodyFinalizeCallWithFileInternalConversationFinalizeCallWithFilePost,
      params: RequestParams = {},
    ) =>
      this.request<FinalizeCallResponse, HTTPValidationError>({
        path: `/internal/conversation/finalize_call_with_file`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Принимает чанки транскрипции от Meet и обрабатывает их.
     *
     * @tags Internal
     * @name ReceiveMeetChunkInternalMeetWorkspacesWorkspaceIdChunkPost
     * @summary Принять чанк транскрипции от Meet
     * @request POST:/internal/meet/workspaces/{workspace_id}/chunk
     * @secure
     */
    receiveMeetChunkInternalMeetWorkspacesWorkspaceIdChunkPost: (
      workspaceId: string,
      data: MeetChunkRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetChunkResponse, HTTPValidationError>({
        path: `/internal/meet/workspaces/${workspaceId}/chunk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  webhooks = {
    /**
     * No description
     *
     * @tags Webhooks
     * @name ReceiveProtocolWebhooksProtocolsPost
     * @summary Принять протокол встречи от внешней системы
     * @request POST:/webhooks/protocols
     * @secure
     */
    receiveProtocolWebhooksProtocolsPost: (
      data: WebhookProtocolRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/webhooks/protocols`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  providers = {
    /**
     * @description Создать workspace и комнату в Meet через Server API.
     *
     * @tags Meet Provider
     * @name CreateMeetWorkspaceProvidersMeetWorkspacesPost
     * @summary Создать workspace Meet с комнатой
     * @request POST:/providers/meet/workspaces
     * @secure
     */
    createMeetWorkspaceProvidersMeetWorkspacesPost: (
      data: MeetWorkspaceCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetWorkspaceCreateResponse, HTTPValidationError>({
        path: `/providers/meet/workspaces`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить детали Meet workspace с ссылкой на комнату.
     *
     * @tags Meet Provider
     * @name GetMeetWorkspaceProvidersMeetWorkspacesWorkspaceIdGet
     * @summary Получить детали Meet workspace
     * @request GET:/providers/meet/workspaces/{workspace_id}
     * @secure
     */
    getMeetWorkspaceProvidersMeetWorkspacesWorkspaceIdGet: (
      workspaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MeetWorkspaceDetailResponse, HTTPValidationError>({
        path: `/providers/meet/workspaces/${workspaceId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name GetInviteProvidersDiscordInviteGet
     * @summary Получить ссылку-приглашение бота
     * @request GET:/providers/discord/invite
     * @secure
     */
    getInviteProvidersDiscordInviteGet: (params: RequestParams = {}) =>
      this.request<InviteResponse, HTTPValidationError>({
        path: `/providers/discord/invite`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name LinkGuildProvidersDiscordGuildsPost
     * @summary Связать гильдию с текущим пользователем
     * @request POST:/providers/discord/guilds
     * @secure
     */
    linkGuildProvidersDiscordGuildsPost: (
      data: LinkGuildRequest,
      params: RequestParams = {},
    ) =>
      this.request<LinkGuildResponse, HTTPValidationError>({
        path: `/providers/discord/guilds`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name ListGuildsProvidersDiscordGuildsGet
     * @summary Список гильдий
     * @request GET:/providers/discord/guilds
     * @secure
     */
    listGuildsProvidersDiscordGuildsGet: (
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Page Size
         * @min 1
         * @max 100
         * @default 20
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedResponseGuildSummary, HTTPValidationError>({
        path: `/providers/discord/guilds`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name ListVoiceChannelsProvidersDiscordVoiceChannelsGet
     * @summary Получить список голосовых каналов гильдии
     * @request GET:/providers/discord/voice/channels
     * @secure
     */
    listVoiceChannelsProvidersDiscordVoiceChannelsGet: (
      query: {
        /** Guild Id */
        guild_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VoiceChannelsResponse, HTTPValidationError>({
        path: `/providers/discord/voice/channels`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name ConnectVoiceProvidersDiscordVoiceConnectPost
     * @summary Подключить бота к голосовому каналу
     * @request POST:/providers/discord/voice/connect
     * @secure
     */
    connectVoiceProvidersDiscordVoiceConnectPost: (
      data: VoiceConnectRequest,
      params: RequestParams = {},
    ) =>
      this.request<VoiceOperationResponse, HTTPValidationError>({
        path: `/providers/discord/voice/connect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name DisconnectVoiceProvidersDiscordVoiceDisconnectPost
     * @summary Отключить бота от голосового канала
     * @request POST:/providers/discord/voice/disconnect
     * @secure
     */
    disconnectVoiceProvidersDiscordVoiceDisconnectPost: (
      data: VoiceDisconnectRequest,
      params: RequestParams = {},
    ) =>
      this.request<VoiceOperationResponse, HTTPValidationError>({
        path: `/providers/discord/voice/disconnect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers
     * @name ListProvidersProvidersGet
     * @summary List Providers
     * @request GET:/providers
     * @secure
     */
    listProvidersProvidersGet: (params: RequestParams = {}) =>
      this.request<ProviderListResponse, HTTPValidationError>({
        path: `/providers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers
     * @name CreateWorkspaceProvidersProviderIdWorkspacesPost
     * @summary Create Workspace
     * @request POST:/providers/{provider_id}/workspaces
     * @secure
     */
    createWorkspaceProvidersProviderIdWorkspacesPost: (
      providerId: string,
      data: WorkspaceCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceCreateResponse, HTTPValidationError>({
        path: `/providers/${providerId}/workspaces`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Удаляет workspace и все связанные данные (конверсации, участники и т.д.)
     *
     * @tags Providers
     * @name DeleteWorkspaceProvidersProviderIdWorkspacesWorkspaceIdDelete
     * @summary Удалить workspace
     * @request DELETE:/providers/{provider_id}/workspaces/{workspace_id}
     * @secure
     */
    deleteWorkspaceProvidersProviderIdWorkspacesWorkspaceIdDelete: (
      providerId: string,
      workspaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceDeleteResponse, HTTPValidationError>({
        path: `/providers/${providerId}/workspaces/${workspaceId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  meetingGroups = {
    /**
     * No description
     *
     * @tags Meeting Groups
     * @name ListMeetingGroupsMeetingGroupsGet
     * @summary List Meeting Groups
     * @request GET:/meeting-groups
     * @secure
     */
    listMeetingGroupsMeetingGroupsGet: (params: RequestParams = {}) =>
      this.request<MeetingGroupListResponse, HTTPValidationError>({
        path: `/meeting-groups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name CreateMeetingGroupMeetingGroupsPost
     * @summary Create Meeting Group
     * @request POST:/meeting-groups
     * @secure
     */
    createMeetingGroupMeetingGroupsPost: (
      data: MeetingGroupCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupResponse, HTTPValidationError>({
        path: `/meeting-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name GetMeetingGroupMeetingGroupsMeetingGroupIdGet
     * @summary Get Meeting Group
     * @request GET:/meeting-groups/{meeting_group_id}
     * @secure
     */
    getMeetingGroupMeetingGroupsMeetingGroupIdGet: (
      meetingGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupResponse, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name UpdateMeetingGroupMeetingGroupsMeetingGroupIdPatch
     * @summary Update Meeting Group
     * @request PATCH:/meeting-groups/{meeting_group_id}
     * @secure
     */
    updateMeetingGroupMeetingGroupsMeetingGroupIdPatch: (
      meetingGroupId: string,
      data: MeetingGroupUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupResponse, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name DeleteMeetingGroupMeetingGroupsMeetingGroupIdDelete
     * @summary Delete Meeting Group
     * @request DELETE:/meeting-groups/{meeting_group_id}
     * @secure
     */
    deleteMeetingGroupMeetingGroupsMeetingGroupIdDelete: (
      meetingGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name AddMeetingGroupMemberMeetingGroupsMeetingGroupIdMembersPost
     * @summary Add Meeting Group Member
     * @request POST:/meeting-groups/{meeting_group_id}/members
     * @secure
     */
    addMeetingGroupMemberMeetingGroupsMeetingGroupIdMembersPost: (
      meetingGroupId: string,
      data: MeetingGroupMemberAddRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupMemberAddRequest, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}/members`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name RemoveMeetingGroupMemberMeetingGroupsMeetingGroupIdMembersUserIdDelete
     * @summary Remove Meeting Group Member
     * @request DELETE:/meeting-groups/{meeting_group_id}/members/{user_id}
     * @secure
     */
    removeMeetingGroupMemberMeetingGroupsMeetingGroupIdMembersUserIdDelete: (
      meetingGroupId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}/members/${userId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  conversations = {
    /**
     * No description
     *
     * @tags Orchestrator
     * @name CreateConversationConversationsPost
     * @summary Create Conversation
     * @request POST:/conversations
     * @secure
     */
    createConversationConversationsPost: (
      data: ConversationCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name ListConversationsConversationsGet
     * @summary List Conversations
     * @request GET:/conversations
     * @secure
     */
    listConversationsConversationsGet: (
      query?: {
        /** Workspace Id */
        workspace_id?: string | null;
        /** Provider Id */
        provider_id?: string | null;
        /** Meeting Group Id */
        meeting_group_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConversationListResponse, HTTPValidationError>({
        path: `/conversations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name StartConversationConversationsConversationIdStartPost
     * @summary Start Conversation
     * @request POST:/conversations/{conversation_id}/start
     * @secure
     */
    startConversationConversationsConversationIdStartPost: (
      conversationId: string,
      data: ConversationStartPayload,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/start`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name CompleteConversationConversationsConversationIdCompletePost
     * @summary Complete Conversation
     * @request POST:/conversations/{conversation_id}/complete
     * @secure
     */
    completeConversationConversationsConversationIdCompletePost: (
      conversationId: string,
      data: ConversationCompletePayload,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/complete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name FinalizeConversationConversationsConversationIdFinalizePost
     * @summary Finalize Conversation
     * @request POST:/conversations/{conversation_id}/finalize
     * @secure
     */
    finalizeConversationConversationsConversationIdFinalizePost: (
      conversationId: string,
      data: ConversationFinalizePayload,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/finalize`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name GetConversationConversationsConversationIdGet
     * @summary Get Conversation
     * @request GET:/conversations/{conversation_id}
     * @secure
     */
    getConversationConversationsConversationIdGet: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete conversation
     *
     * @tags Orchestrator
     * @name DeleteConversationConversationsConversationIdDelete
     * @summary Delete Conversation
     * @request DELETE:/conversations/{conversation_id}
     * @secure
     */
    deleteConversationConversationsConversationIdDelete: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/conversations/${conversationId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Возвращает чанки разговора с пагинацией.
     *
     * @tags Orchestrator
     * @name GetConversationChunksConversationsConversationIdChunksGet
     * @summary Получить чанки разговора
     * @request GET:/conversations/{conversation_id}/chunks
     * @secure
     */
    getConversationChunksConversationsConversationIdChunksGet: (
      conversationId: string,
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Page Size
         * @min 1
         * @max 200
         * @default 50
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConversationChunksResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/chunks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name MergeConversationsConversationsMergePost
     * @summary Merge Conversations
     * @request POST:/conversations/merge
     * @secure
     */
    mergeConversationsConversationsMergePost: (
      data: ConversationMergeRequest,
      params: RequestParams = {},
    ) =>
      this.request<ConversationMergeResponse, HTTPValidationError>({
        path: `/conversations/merge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создает несколько тестовых чанков транскрипции для указанной конверсации
     *
     * @tags Orchestrator
     * @name CreateTestChunksConversationsConversationIdTestChunksPost
     * @summary Создать тестовые чанки для конверсации
     * @request POST:/conversations/{conversation_id}/test-chunks
     * @secure
     */
    createTestChunksConversationsConversationIdTestChunksPost: (
      conversationId: string,
      data: TestChunksRequest,
      params: RequestParams = {},
    ) =>
      this.request<TestChunksResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/test-chunks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновляет статус и/или субстатус разговора. Доступно только для AI-сервиса.
     *
     * @tags Orchestrator
     * @name UpdateConversationStatusConversationsConversationIdStatusPost
     * @summary Обновить статус разговора
     * @request POST:/conversations/{conversation_id}/status
     * @secure
     */
    updateConversationStatusConversationsConversationIdStatusPost: (
      conversationId: string,
      data: ConversationStatusUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ListReportsConversationsConversationIdReportsGet
     * @summary List Reports
     * @request GET:/conversations/{conversation_id}/reports
     * @secure
     */
    listReportsConversationsConversationIdReportsGet: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportDTO[], HTTPValidationError>({
        path: `/conversations/${conversationId}/reports`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name CreateReportConversationsConversationIdReportsPost
     * @summary Create Report
     * @request POST:/conversations/{conversation_id}/reports
     * @secure
     */
    createReportConversationsConversationIdReportsPost: (
      conversationId: string,
      data: ConversationReportCreate,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportDTO, HTTPValidationError>({
        path: `/conversations/${conversationId}/reports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Атомарно создаёт несколько репортов и их айтемы в одной транзакции
     *
     * @tags Reports
     * @name CreateReportsBatchConversationsConversationIdReportsBatchPost
     * @summary Массовое создание репортов с айтемами
     * @request POST:/conversations/{conversation_id}/reports/batch
     * @secure
     */
    createReportsBatchConversationsConversationIdReportsBatchPost: (
      conversationId: string,
      data: ConversationReportsBatchCreate,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/conversations/${conversationId}/reports/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a tree structure of all reports and their items for a conversation, containing only IDs and titles.
     *
     * @tags Reports
     * @name GetReportsTreeConversationsConversationIdReportsTreeGet
     * @summary Get a lightweight tree of reports and their items
     * @request GET:/conversations/{conversation_id}/reports/tree
     * @secure
     */
    getReportsTreeConversationsConversationIdReportsTreeGet: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<ReportTreeResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/reports/tree`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  config = {
    /**
     * @description Возвращает переводы статусов и субстатусов разговоров на русский язык.
     *
     * @tags Orchestrator
     * @name GetStatusMappingsConfigStatusMappingsGet
     * @summary Получить переводы статусов
     * @request GET:/config/status-mappings
     * @secure
     */
    getStatusMappingsConfigStatusMappingsGet: (params: RequestParams = {}) =>
      this.request<StatusMappingsResponse, any>({
        path: `/config/status-mappings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  workspaces = {
    /**
     * @description Завершить все активные сессии для workspace.
     *
     * @tags Orchestrator
     * @name EndAllWorkspaceSessionsWorkspacesWorkspaceIdEndAllSessionsPost
     * @summary End All Workspace Sessions
     * @request POST:/workspaces/{workspace_id}/end-all-sessions
     * @secure
     */
    endAllWorkspaceSessionsWorkspacesWorkspaceIdEndAllSessionsPost: (
      workspaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/workspaces/${workspaceId}/end-all-sessions`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name ListWorkspacesWorkspacesGet
     * @summary List Workspaces
     * @request GET:/workspaces
     * @secure
     */
    listWorkspacesWorkspacesGet: (
      query?: {
        /**
         * Provider Id
         * Filter workspaces by provider ID
         */
        provider_id?: string | null;
        /**
         * Default Meeting Group Id
         * Filter workspaces by default meeting group ID
         */
        default_meeting_group_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceListResponse, HTTPValidationError>({
        path: `/workspaces`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workspaces
     * @name UpdateWorkspaceWorkspacesWorkspaceIdPatch
     * @summary Update Workspace
     * @request PATCH:/workspaces/{workspace_id}
     * @secure
     */
    updateWorkspaceWorkspacesWorkspaceIdPatch: (
      workspaceId: string,
      data: WorkspaceUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceResponse, HTTPValidationError>({
        path: `/workspaces/${workspaceId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workspaces
     * @name DeleteWorkspaceWorkspacesWorkspaceIdDelete
     * @summary Delete Workspace
     * @request DELETE:/workspaces/{workspace_id}
     * @secure
     */
    deleteWorkspaceWorkspacesWorkspaceIdDelete: (
      workspaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/workspaces/${workspaceId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  chunks = {
    /**
     * No description
     *
     * @tags Orchestrator
     * @name EnqueueChunkChunksPost
     * @summary Enqueue Chunk
     * @request POST:/chunks
     * @secure
     */
    enqueueChunkChunksPost: (data: ChunkPayload, params: RequestParams = {}) =>
      this.request<ChunkEnqueueResponse, HTTPValidationError>({
        path: `/chunks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  events = {
    /**
     * @description Позволяет коннектору отправить произвольное событие в оркестратор (без HMAC).
     *
     * @tags Orchestrator
     * @name PublishEventEventsPost
     * @summary Публикация внешнего события
     * @request POST:/events
     * @secure
     */
    publishEventEventsPost: (data: EventPayload, params: RequestParams = {}) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  healthz = {
    /**
     * No description
     *
     * @tags Internal
     * @name HealthzHealthzGet
     * @summary Проверка состояния сервиса
     * @request GET:/healthz
     * @secure
     */
    healthzHealthzGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/healthz`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  reports = {
    /**
     * No description
     *
     * @tags Reports
     * @name GetReportReportsReportIdGet
     * @summary Get Report
     * @request GET:/reports/{report_id}
     * @secure
     */
    getReportReportsReportIdGet: (
      reportId: string,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportDTO, HTTPValidationError>({
        path: `/reports/${reportId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name DeleteReportReportsReportIdDelete
     * @summary Delete Report
     * @request DELETE:/reports/{report_id}
     * @secure
     */
    deleteReportReportsReportIdDelete: (
      reportId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/reports/${reportId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ListItemsReportsReportIdItemsGet
     * @summary List Items
     * @request GET:/reports/{report_id}/items
     * @secure
     */
    listItemsReportsReportIdItemsGet: (
      reportId: string,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportItemDTO[], HTTPValidationError>({
        path: `/reports/${reportId}/items`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Manually handle the creation of a ConversationReportItem to correctly map the 'data' field to the 'data_json' column in the database, bypassing the repository's abstract method.
     *
     * @tags Reports
     * @name AddItemReportsReportIdItemsPost
     * @summary Add Item
     * @request POST:/reports/{report_id}/items
     * @secure
     */
    addItemReportsReportIdItemsPost: (
      reportId: string,
      data: ConversationReportItemCreate,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportItemDTO, HTTPValidationError>({
        path: `/reports/${reportId}/items`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name DeleteItemReportsItemsItemIdDelete
     * @summary Delete Item
     * @request DELETE:/reports/items/{item_id}
     * @secure
     */
    deleteItemReportsItemsItemIdDelete: (
      itemId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/reports/items/${itemId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name UpdateItemReportsItemsItemIdPut
     * @summary Update Item
     * @request PUT:/reports/items/{item_id}
     * @secure
     */
    updateItemReportsItemsItemIdPut: (
      itemId: string,
      data: ConversationReportItemUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportItemDTO, HTTPValidationError>({
        path: `/reports/items/${itemId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  v1 = {
    /**
     * No description
     *
     * @tags Reports
     * @name CreateReportFromAiV1ReportsAiPost
     * @summary Create Report From Ai
     * @request POST:/v1/reports/ai
     * @secure
     */
    createReportFromAiV1ReportsAiPost: (
      data: ConversationReportsBatchCreate,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportWithItemsDTO, HTTPValidationError>({
        path: `/v1/reports/ai`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
